var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostFrame',_vm._b({},'PostFrame',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('ThumbnailPostTitle',{attrs:{"post":_vm.post}}),_vm._v(" "),_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8ba2572","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThumbnailPost.vue
// module id = tUED
// module chunks = 1